import { useQuery } from 'react-query';

import { request } from '@/utils';
import { searchUserV3 } from '@/hooks';

export const getTagSuggestionList = async (
  q: string,
): Promise<{
  tags: { id: string; raw_string: string }[];
}> => {
  if (!q) {
    return Promise.resolve({
      tags: [],
    });
  }
  return request.get(`/feed/suggested_tags`, { q });
};
export const getMentionSuggestionList = async (
  q: string,
): Promise<{
  mentions: { id: string; raw_string: string }[];
}> => {
  if (!q) {
    return Promise.resolve({
      mentions: [],
    });
  }
  return request.get(`/feed/suggested_mentions`, { q });
};

export const getMentionSuggestion = async (
  q: string,
): Promise<{
  mention?: { id: string; raw_string: string };
}> => {
  if (!q) {
    return Promise.resolve({});
  }
  return request.get(`/feed/suggested_mention`, { q });
};

export const useStreamSearchSuggestionList = (keyword: string, disabled?: boolean) => {
  const query = useQuery(
    ['stream-search-suggestion-list', keyword],
    async () => {
      return await Promise.all([
        getTagSuggestionList(keyword).then(res => res?.tags || []),
        getMentionSuggestionList(keyword).then(res => res?.mentions || []),
      ]).then(data => {
        const list = [];
        const tagList = data[0];
        const mentionList = data[1];
        tagList[0] && list.push(tagList[0]);
        mentionList[0] && list.push(mentionList[0]);
        if (list.length < 2 && (tagList[1] || mentionList[1])) {
          list.push(tagList[1] || mentionList[1]);
        }

        return list;
      });
    },
    {
      enabled: !!keyword && !disabled,
    },
  );

  return query;
};

export const useStreamSearchSuggestionMention = (keyword: string, enabled?: boolean) => {
  const query = useQuery(
    ['stream-search-suggestion-mention', keyword],
    async () => await searchUserV3(keyword).then(res => res?.users[0]),
    {
      enabled: !!keyword && enabled,
    },
  );

  return query;
};
